import { CheckedComponentInformation } from '@west-australian-newspapers/json-react-layouts'
import { Topic } from '@news-mono/web-common'
import { layout } from '../../../../App.routing'
import { getAflCurationSierraComponent } from '../afl-route-component-layouts'

const bannerDesktopX1 = require<string>('./assets/2025-AFL-Footy-Lives-Here-Desktop-Banner-@1x.jpg')
const bannerDesktopX2 = require<string>('./assets/2025-AFL-Footy-Lives-Here-Desktop-Banner-@2x.jpg')
const bannerMobileX1 = require<string>('./assets/2025-AFL-Footy-Lives-Here-Mobile-Banner-@1x.jpg')
const bannerMobileX2 = require<string>('./assets/2025-AFL-Footy-Lives-Here-Mobile-Banner-@2x.jpg')
const socialImage = require('./assets/2025-AFL-Footy-Lives-Here-Social-Image.jpg')

export const getFootyLivesHereSocialImageMeta = (topic: Topic) => [
    {
        property: 'og:image',
        content: socialImage,
    },
    {
        property: 'og:image:width',
        content: '1920',
    },
    {
        property: 'og:image:height',
        content: '1080',
    },
    { name: 'twitter:image', content: socialImage },
    {
        property: 'og:description',
        content: topic.seoDescription,
    },
    {
        property: 'twitter:description',
        content: topic.seoDescription,
    },
]

export const getFootyLivesHereHeader = (
    topic: Topic,
): CheckedComponentInformation[] => {
    return [
        layout.component({
            type: 'image-banner',
            props: {
                defaultSrc: bannerDesktopX2,
                verticalGutters: ['unset', 'md'],
                altText: topic.seoTitle,
                disableHeader: true,
                sources: [
                    {
                        breakpoint: 'sm',
                        src: [
                            {
                                src: bannerDesktopX1,
                                density: '1x',
                            },
                            {
                                src: bannerDesktopX2,
                                density: '2x',
                            },
                        ],
                    },
                    {
                        src: [
                            {
                                src: bannerMobileX1,
                                density: '1x',
                            },
                            {
                                src: bannerMobileX2,
                                density: '2x',
                            },
                        ],
                    },
                ],
            },
        }),
        layout.nestedComposition({
            type: 'janus',
            props: {
                layoutRatio: '3:1',
                stretchColumns: true,
                verticalSpacing: 'xl',
            },
            contentAreas: {
                left: [getAflCurationSierraComponent()],
                right: [
                    layout.component({
                        type: 'footy-lives-here-promo-card',
                        props: {},
                    }),
                ],
            },
        }),
    ]
}
